import { onScopeDispose } from "vue";
/**
 * Runs `refetch` each time the document becomes visible again (the user comes back to this
 * browser tab), for a view whose figures are written from another screen — an edit made in a
 * second tab is then reflected without a reload. Nothing runs while the tab is hidden, and the
 * listener leaves with the component's scope.
 */
export function useRefetchOnVisible(refetch) {
    if (typeof document === "undefined")
        return;
    function onVisibilityChange() {
        if (!document.hidden)
            refetch();
    }
    document.addEventListener("visibilitychange", onVisibilityChange);
    onScopeDispose(() => document.removeEventListener("visibilitychange", onVisibilityChange));
}
